import { render } from "./OpportunityManagement.vue?vue&type=template&id=27c5ec0a&scoped=true"
import script from "./OpportunityManagement.vue?vue&type=script&lang=js"
export * from "./OpportunityManagement.vue?vue&type=script&lang=js"

import "./OpportunityManagement.vue?vue&type=style&index=0&id=27c5ec0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c5ec0a"]])

export default __exports__